import {CalculatorClass as Calculator} from "./CalculatorClass";

window.Calculator = Calculator;
